import image1 from '../../../images/page_1_slide_1_add_frame.gif'
import image2 from '../../../images/page_1_slide_2_body_movement.gif'
import image3 from '../../../images/page_1_slide_3_moods.gif'
import image4 from '../../../images/page_1_slide_4_rec.gif'
export const sliderdata = [
    {
        id: 0,
        title: 'Easiest way to create animation movies',
        info: "Tweencaft allows anyone to create animation movies with ease. No prior knowledge of tools or animation basics is required to use the app",
        image: image1,
        boxInfo: 'Add frame and play video to show animation',
    },
    {
        id: 1,
        title: 'Animate and move characters on your fingertips',
        info: 'Tweencraft provides simple gesture based fluid body movements for easy animation',
        image: image2,
        boxInfo: 'Video showing character movements on touch gesture'
    },
    {
        id: 2,
        title: 'Awesome character library with built in expressions and actions',
        info: 'In built characters and expressions make it very easy to show moods and expressions',
        image: image3,
        boxInfo: 'Video showing character expression selection and on play action as well',
    },
    {
        id: 3,
        title: 'Press and record dialogues for cartoons and modify easily',
        info: 'Just record a dialogue and we sync it with characters lip movement, face and gender with cartoonish tone',
        image: image4,
        boxInfo: 'Show voice record'
    }
]